import React, { useState } from 'react';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ProductManagement from './ProductManagement';
import ProjectManagement from './ProjectManagement';
import ServiceManagement from './ServiceManagement';
import OrderManagement from './OrderManagement';
import UserManagement from './UserManagement';
import TeamManagement from './TeamManagement';
import Statistics from './Statistics';
import AboutVideoManagement from './AboutVideoManagement';
import VacatureManagement from './VacatureManagement';
import StickerExampleManagement from './StickerExampleManagement';
import StickerSizeManagement from './StickerSizeManagement';
import FeedbackManagement from '../../components/FeedbackManagement';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { path: '/admin', label: 'Overzicht', icon: '📊' },
    { path: '/admin/stats', label: 'Statistieken', icon: '📈' },
    { path: '/admin/projects', label: 'Projecten', icon: '📁' },
    { path: '/admin/services', label: 'Diensten', icon: '⚙️' },
    { path: '/admin/team', label: 'Team', icon: '👤' },
    { path: '/admin/products', label: 'Producten', icon: '🛍️' },
    { path: '/admin/orders', label: 'Bestellingen', icon: '📦' },
    { path: '/admin/vacatures', label: 'Vacatures', icon: '💼' },
    { path: '/admin/users', label: 'Gebruikers', icon: '👥' },
    { path: '/admin/about-video', label: 'Over Ons Video', icon: '🎬' },
    { path: '/admin/sticker-examples', label: 'Sticker Voorbeelden', icon: '🏷️' },
    { path: '/admin/sticker-sizes', label: 'Sticker Formaten', icon: '📐' },
    { path: '/admin/feedback', label: 'Feedback', icon: '💬' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="admin-container">
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Beheerderspaneel</h2>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(false)}
          >
            ✕
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button
            className="logout-btn"
            onClick={() => {
              logout();
              navigate('/');
            }}
          >
            Uitloggen
          </button>
        </div>
      </aside>

      <div className="admin-content">
        <button
          className="mobile-menu-btn"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          ☰
        </button>

        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/stats" element={<Statistics />} />
          <Route path="/products" element={<ProductManagement />} />
          <Route path="/projects" element={<ProjectManagement />} />
          <Route path="/services" element={<ServiceManagement />} />
          <Route path="/team" element={<TeamManagement />} />

          <Route path="/orders" element={<OrderManagement />} />
          <Route path="/users" element={<UserManagement />} />
          <Route path="/about-video" element={<AboutVideoManagement />} />
          <Route path="/vacatures" element={<VacatureManagement />} />
          <Route path="/sticker-examples" element={<StickerExampleManagement />} />
          <Route path="/sticker-sizes" element={<StickerSizeManagement />} />
          <Route path="/feedback" element={<FeedbackManagement />} />
        </Routes>
      </div>
    </div>
  );
};

const Overview = () => (
  <div className="admin-page">
    <h1>Beheerderspaneel</h1>
    <div className="overview-grid">
      <div className="overview-card">
        <h3>Statistieken</h3>
        <p className="overview-stat">Omzet, bestellingen & aantallen</p>
        <Link to="/admin/stats" className="overview-link">
          Naar Statistieken →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Producten</h3>
        <p className="overview-stat">Beheer alle producten</p>
        <Link to="/admin/products" className="overview-link">
          Naar Producten →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Projecten</h3>
        <p className="overview-stat">Beheer alle projecten</p>
        <Link to="/admin/projects" className="overview-link">
          Naar Projecten →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Diensten</h3>
        <p className="overview-stat">Beheer alle diensten</p>
        <Link to="/admin/services" className="overview-link">
          Naar Diensten →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Bestellingen</h3>
        <p className="overview-stat">Beheer alle bestellingen</p>
        <Link to="/admin/orders" className="overview-link">
          Naar Bestellingen →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Gebruikers</h3>
        <p className="overview-stat">Beheer alle gebruikers</p>
        <Link to="/admin/users" className="overview-link">
          Naar Gebruikers →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Team</h3>
        <p className="overview-stat">Beheer teamleden</p>
        <Link to="/admin/team" className="overview-link">
          Naar Team →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Vacatures</h3>
        <p className="overview-stat">Beheer openstaande vacatures</p>
        <Link to="/admin/vacatures" className="overview-link">
          Naar Vacatures →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Sticker Voorbeelden</h3>
        <p className="overview-stat">Beheer de voorbeelden in de sticker-configurator</p>
        <Link to="/admin/sticker-examples" className="overview-link">
          Naar Sticker Voorbeelden →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Sticker Formaten</h3>
        <p className="overview-stat">Beheer prijzen en afmetingen van sticker-formaten</p>
        <Link to="/admin/sticker-sizes" className="overview-link">
          Naar Sticker Formaten →
        </Link>
      </div>
      <div className="overview-card">
        <h3>Feedback</h3>
        <p className="overview-stat">Beheer klantbeoordelingen & reviews</p>
        <Link to="/admin/feedback" className="overview-link">
          Naar Feedback →
        </Link>
      </div>
    </div>
  </div>
);

export default AdminDashboard;
